export const GA_MEASUREMENT_ID = "G-4G3K0DXTV8";

export const pageview = url => {
    window.gtag("config", GA_MEASUREMENT_ID, {
        page_path: url,
    });
};

export const event = ({ action, params }) => {
    window.gtag('event', action, params)
  };